/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_Provider_NoneInputs */

const vi_vehicle_gps_provider_none = /** @type {(inputs: Vehicle_Gps_Provider_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có`)
};

/**

* @param {Vehicle_Gps_Provider_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_provider_none = /** @type {((inputs?: Vehicle_Gps_Provider_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_Provider_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_provider_none(inputs)
});